import { useTranslation } from 'react-i18next'

import { Alert, Text, VStack } from '@enechain/ecloud-designsystem'

import { Modal } from '~/components/common/Modal'
import { SaveCancelFooter } from '~/components/common/Modal/SaveCancelFooter'
import type { DecisionAction } from '~/pages/AdminApprovalTasks/models/approvalDecisionFailure'

type Props = {
  isOpen: boolean
  action: DecisionAction
  /** 承認者でない・自己承認の再確認の文 (両方に当たる時は 1 つのモーダルに両方を並べる)。 */
  messages: readonly string[]
  onCancel: () => void
  /** 確定。 呼び出し元が承認確認ダイアログ (AC-APT-007) / 差戻し確認ダイアログ (AC-APT-009) を開く。 */
  onConfirm: () => void
}

/**
 * 承認者でない人・申請者本人が承認・差戻しを押した時の確認モーダル (AC-APT-019a)。
 * 明示的な再確認を経てから承認確認ダイアログ・差戻し確認ダイアログに進む。 自己承認・承認者以外を
 * 止めはしない (緊急対応を塞がない)。 題名は 8080 プロトに合わせ「申請の承認」「申請の差戻し」、
 * 確定ボタンは操作名 (スポット入札画面 AC-BSP-098 の確認モーダルの型)。
 */
export const ApproverGuardModal = ({
  isOpen,
  action,
  messages,
  onCancel,
  onConfirm,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Modal
      footer={
        <SaveCancelFooter
          onCancel={onCancel}
          onSave={onConfirm}
          saveLabel={t(
            action === 'approve'
              ? 'page:adminApprovalTasks.action.approve'
              : 'page:adminApprovalTasks.action.reject',
          )}
        />
      }
      isOpen={isOpen}
      onClose={onCancel}
      size="sm"
      title={t(
        action === 'approve'
          ? 'page:adminApprovalTasks.guardModal.approveTitle'
          : 'page:adminApprovalTasks.guardModal.rejectTitle',
      )}
    >
      <VStack align="stretch" gap={3}>
        {messages.length > 0 && (
          // 先頭の文を見出し、 残りを説明にする (8080 プロトの approval-guard.js と同じ)。
          <Alert
            description={
              messages.length > 1 ? (
                <VStack align="stretch" gap={1}>
                  {messages.slice(1).map((message) => (
                    <Text key={message}>{message}</Text>
                  ))}
                </VStack>
              ) : undefined
            }
            status="warning"
            title={messages[0]}
          />
        )}
      </VStack>
    </Modal>
  )
}
